import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { AjaxService } from '../../../services/ajax.service';
import { ViewScopeService } from '../../../services/view-scope.service';

import { DocumentStatusModel, DocumentGroupsGradesModel, FileFeatureGradeModel} from '../../../models/docoment-status.model';

import { LOAD_ALL_FILES, GET_FILE_STATS, UPD_FILE_STATS, FILE_GRADE_REPORT, FILE_GROUPS_GRADE} from '../../../services/account-api.constants';


export interface GlobalTableInfo {
	FileRecID						: number;
	SupplierRecID					: number;
	OriginalFileName				: string;
	DocNumber 						: string;
	FileCategory					: string;
	DateEntered						: string;
	FilePublishDate					: string;
	Business_ID						: string | null;
	CustomerName					: string | null;
	total_discount					: string | null;
	tax								: string;
	total_with_tax					: string | null;
	total_without_tax				: string | null;
	vat_in_precentages				: string | null;
	total_after_discount			: string | null;
	allocation_number				: string | null;
	URL								: string;
	customer_supplier_num			: string | null;
	CustomerSupplierExpenseCode		: string | null;
	CustomerSupplierExpenseCodeName	: string | null;
	Sug_tnua						: string | null;
}

@Injectable({
  providedIn: 'root'
})

export class DocApprovalService 
{
	public dialogChangesMade = false;   // For tracing if eye-dialog made any changes.

	constructor(
		private viewScopeService: ViewScopeService,
		private ajaxService: AjaxService,
	) 
	{ }

	public loadAllFiles(gradeLevel: number): Observable<GlobalTableInfo[]> {
		const url = this.ajaxService.getBaseOfApi() + LOAD_ALL_FILES + '/' +
			this.viewScopeService.getCurrentCustomer() + '/' +
			gradeLevel + '/' +
			this.viewScopeService.getCurrentOpertaingUserId();

		return this.ajaxService.getData(url).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => ({
					FileRecID: item.FileRecID,
					SupplierRecID : item.SupplierRecID,
					OriginalFileName: item.OriginalFileName,
					DocNumber : item.doc_num,
					FileCategory: item.FileCategory,
					DateEntered: item.DateEntered,
					FilePublishDate: item.doc_publish_date,
					Business_ID: item.Business_ID,
					CustomerName: item.CustomerName,
					tax: item.tax,
					total_discount: item.total_discount,
					total_with_tax: item.total_with_tax,
					total_without_tax: item.total_without_tax,
					vat_in_precentages: item.vat_in_precentages,
					total_after_discount: item.total_after_discount,
					allocation_number: item.allocation_number,
					URL: item.url,
					customer_supplier_num: item.customer_supplier_num,
					CustomerSupplierExpenseCode: item.CustomerSupplierExpenseCode,
					CustomerSupplierExpenseCodeName: item.Kheshbon_Khova_1_name,
					Sug_tnua: item.Sug_tnua
				})) as GlobalTableInfo[];
			}),
			catchError(error => {
				console.error('Error fetching files:', error);
				return of([]); // fallback: empty array
			})
		);
	}

	public getFilesClassifications(): Observable<DocumentStatusModel[]>
	{
		const url = this.ajaxService.getBaseOfApi() + GET_FILE_STATS + "0/" + this.viewScopeService.getCurrentOpertaingUserId(); 
		return this.ajaxService.getData(url).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => ({
					FileGradeClassificationRecID: item.FileGradeClassificationRecID,
					FileGradeClassification		: item.FileGradeClassification,
					Grade						: item.Grade,
					Code						: item.Code,
					Descr						: item.Descr,
					IconGrade					: item.IconGrade,
					IsHistory 					: item.IsHistory
				})) as DocumentStatusModel[];
			}),
			catchError(error => {
				console.error('Error fetching files:', error);
				return of([]); // fallback: empty array
			})
		);
	}


	
	public reassignFilesClassification(newCode : string, fileRecID: number): Observable<any>
	{
		const url = this.ajaxService.getBaseOfApi() + UPD_FILE_STATS;
		const payload = JSON.stringify({
			"code"		: newCode,
			"FileRecID"	: fileRecID,
			"UserRecID" 	: this.viewScopeService.getCurrentOpertaingUserId()
		});
		console.log('reassignFilesClassification payload:', payload);

		return this.ajaxService.updateObjectData(url,payload);
	}


	public getGroupsGradesForFile(fileID: number):Observable<DocumentGroupsGradesModel[]>
	{
		
		const url = this.ajaxService.getBaseOfApi() + FILE_GROUPS_GRADE + fileID + "/" + this.viewScopeService.getCurrentOpertaingUserId(); 
		return this.ajaxService.getData(url).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => (
				{
					File_FF_GroupGradeRecID	: item.File_FF_GroupGradeRecID,
					NotificationGradeRecID	: item.NotificationGradeRecID,
					FileCategory			: item.FileCategory,
					NotificationGradeCode	: item.NotificationGradeCode,
					NotificationGradeGrade	: item.NotificationGradeGrade,
					NotificationGradeDescr	: item.NotificationGradeDescr,
					ColorNotification		: item.ColorNotification,
					NotificationType		: item.NotificationType,
					NotificationTypeCode	: item.NotificationTypeCode
				})) as DocumentGroupsGradesModel[];
			}),
			catchError(error => {
				console.error('Error fetching files:', error);
				return of([]); // fallback: empty array
			})
		);
	}


	public getFeaturesGradesForFile(fileID: number):Observable<FileFeatureGradeModel[]>
	{
		
		const url = this.ajaxService.getBaseOfApi() + FILE_GRADE_REPORT + fileID + "/" + this.viewScopeService.getCurrentOpertaingUserId(); 
		return this.ajaxService.getData(url).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => (
				{
					FileFeatureRecID		: item.FileFeatureRecID,
					FeatureRecID			: item.FeatureRecID,
					FeatureGradeSheetRecID	: item.FeatureGradeSheetRecID,
					Feature					: item.Feature,
					FeatureTranslation		: item.FeatureTranslation,
					FeatureGradeDescr		: item.FeatureGradeDescr,
					Grade					: item.Grade,
					ColorNotification		: item.ColorNotification,
					FeatureErrorType		: item.FeatureErrorType,
					content_str				: item.content_str,
					NotificationType		: item.NotificationType,
					NotificationTypeCode	: item.NotificationTypeCode
					
				})) as FileFeatureGradeModel[];
			}),
			catchError(error => {
				console.error('Error fetching files:', error);
				return of([]); // fallback: empty array
			})
		);
	}

	//

}